// Translation of interface text. User content (names, teams, notes and inputs)
// stays untouched. Text nodes are translated without replacing React elements.
const words: Record<string, string> = {
	Leagues: "Ligas",
	"New League": "Nova liga",
	"New league": "Nova liga",
	"Exhibition Game": "Partida de exibição",
	"Exhibition game": "Partida de exibição",
	Tools: "Ferramentas",
	Help: "Ajuda",
	"Login/Register": "Entrar / Cadastrar",
	Login: "Entrar",
	Register: "Cadastrar",
	Logout: "Sair",
	Dashboard: "Painel",
	"League Dashboard": "Painel da liga",
	League: "Liga",
	Team: "Time",
	Players: "Jogadores",
	Stats: "Estatísticas",
	Play: "Jogar",
	Idle: "Aguardando",
	"Switch League": "Trocar de liga",
	Standings: "Classificação",
	Playoffs: "Playoffs",
	"Daily Schedule": "Calendário diário",
	Finances: "Finanças",
	History: "Histórico",
	"Power Rankings": "Ranking de força",
	Transactions: "Transações",
	"News Feed": "Notícias",
	Notes: "Anotações",
	Roster: "Elenco",
	Schedule: "Calendário",
	"GM History": "Histórico do GM",
	"Free Agents": "Agentes livres",
	Trade: "Trocas",
	"Trading Block": "Balcão de trocas",
	"Trade Proposals": "Propostas de troca",
	"Saved Trades": "Trocas salvas",
	Draft: "Draft",
	"Compare Players": "Comparar jogadores",
	"Watch List": "Lista de interesse",
	"Hall of Fame": "Hall da Fama",
	"Game Log": "Histórico de partidas",
	"League Leaders": "Líderes da liga",
	"Player Ratings": "Atributos dos jogadores",
	"Player Stats": "Estatísticas dos jogadores",
	"Player Bios": "Biografias dos jogadores",
	"Player Graphs": "Gráficos dos jogadores",
	"Advanced Player Search": "Busca avançada de jogadores",
	"Team Stats": "Estatísticas dos times",
	"Team Graphs": "Gráficos dos times",
	"League Stats": "Estatísticas da liga",
	Injuries: "Lesões",
	"Statistical Feats": "Feitos estatísticos",
	"Award Races": "Disputa por prêmios",
	Achievements: "Conquistas",
	"Auto Play": "Simulação automática",
	"Delete Old Data": "Excluir dados antigos",
	"Export League": "Exportar liga",
	"Export Stats": "Exportar estatísticas",
	"Expansion Draft": "Draft de expansão",
	"Fantasy Draft": "Draft de redistribuição",
	Frivolities: "Curiosidades",
	"God Mode": "Modo Deus",
	"Import/Export Players": "Importar / Exportar jogadores",
	"Manage Confs": "Gerenciar conferências",
	"Manage Teams": "Gerenciar times",
	"Schedule Editor": "Editor de calendário",
	"Scheduled Events": "Eventos programados",
	Screenshot: "Captura de tela",
	"Global Settings": "Configurações gerais",
	"League Settings": "Configurações da liga",
	"Award Settings": "Configurações de prêmios",
	"Danger Zone": "Zona de perigo",
	Manual: "Manual",
	"Custom Rosters": "Elencos personalizados",
	Debugging: "Depuração",
	Changelog: "Histórico de atualizações",
	About: "Sobre",
	Blog: "Blog",
	Contact: "Contato",
	Privacy: "Privacidade",
	"Real players": "Jogadores reais",
	"Random players": "Jogadores fictícios",
	"Real players and teams": "Jogadores e times reais",
	"Random players and teams": "Jogadores e times fictícios",
	"Cross-era": "Épocas diferentes",
	Legends: "Lendas",
	Custom: "Personalizada",
	Customize: "Personalizar",
	"Upload league file": "Enviar arquivo de liga",
	"Enter league file URL": "Informar URL do arquivo de liga",
	"League name": "Nome da liga",
	Season: "Temporada",
	"Pick your team": "Escolha seu time",
	Random: "Aleatório",
	Difficulty: "Dificuldade",
	Easy: "Fácil",
	Normal: "Normal",
	Hard: "Difícil",
	Insane: "Insana",
	"Create league": "Criar liga",
	"Import league": "Importar liga",
	"Customize settings": "Personalizar configurações",
	Processing: "Processando",
	Loading: "Carregando",
	"Loading...": "Carregando…",
	Save: "Salvar",
	"Save changes": "Salvar alterações",
	Cancel: "Cancelar",
	Close: "Fechar",
	Confirm: "Confirmar",
	Continue: "Continuar",
	Delete: "Excluir",
	Edit: "Editar",
	Reset: "Redefinir",
	Apply: "Aplicar",
	Search: "Buscar",
	Filter: "Filtrar",
	Filters: "Filtros",
	Show: "Mostrar",
	Hide: "Ocultar",
	All: "Todos",
	None: "Nenhum",
	Yes: "Sim",
	No: "Não",
	Name: "Nome",
	Age: "Idade",
	Position: "Posição",
	Contract: "Contrato",
	Salary: "Salário",
	Years: "Anos",
	Year: "Ano",
	Country: "País",
	College: "Universidade",
	Experience: "Experiência",
	Height: "Altura",
	Weight: "Peso",
	Potential: "Potencial",
	Overall: "Geral",
	Ratings: "Atributos",
	Scouting: "Olheiros",
	Skills: "Habilidades",
	Injury: "Lesão",
	Healthy: "Saudável",
	Retired: "Aposentado",
	Retire: "Aposentar",
	"Draft Pick": "Escolha de draft",
	"Draft Picks": "Escolhas de draft",
	"Draft Class": "Classe do draft",
	"Draft Lottery": "Loteria do draft",
	"Draft History": "Histórico do draft",
	"Draft Scouting": "Observação do draft",
	"Draft Summary": "Resumo do draft",
	"Draft Results": "Resultados do draft",
	"Draft results": "Resultados do draft",
	Round: "Rodada",
	Pick: "Escolha",
	Select: "Selecionar",
	"Draft player": "Selecionar jogador",
	"Draft Player": "Selecionar jogador",
	"Draft Until Your Next Pick": "Avançar até sua próxima escolha",
	"Until your next pick": "Até sua próxima escolha",
	"Until Your Next Pick": "Até sua próxima escolha",
	"One pick": "Uma escolha",
	"One Pick": "Uma escolha",
	"Until end of draft": "Até o fim do draft",
	Undrafted: "Não selecionado",
	Prospects: "Promessas",
	"Available Players": "Jogadores disponíveis",
	"Available players": "Jogadores disponíveis",
	"Drafted Players": "Jogadores selecionados",
	"Drafted players": "Jogadores selecionados",
	"Your team": "Seu time",
	"Your Team": "Seu time",
	"Other team": "Outro time",
	"Other Team": "Outro time",
	"Propose trade": "Propor troca",
	"Propose Trade": "Propor troca",
	"Make it work": "Ajustar proposta",
	"Make It Work": "Ajustar proposta",
	Clear: "Limpar",
	"Clear all": "Limpar tudo",
	"Clear All": "Limpar tudo",
	Accept: "Aceitar",
	Reject: "Recusar",
	Negotiate: "Negociar",
	Sign: "Contratar",
	"Re-sign": "Renovar",
	"Re-sign All": "Renovar com todos",
	"Re-sign all": "Renovar com todos",
	Release: "Dispensar",
	"Release player": "Dispensar jogador",
	"Release Player": "Dispensar jogador",
	"Trade For": "Negociar por",
	"Trade for": "Negociar por",
	"Add to trading block": "Adicionar ao balcão de trocas",
	"Auto-sort roster": "Ordenar elenco automaticamente",
	"Auto-sort": "Ordenar automaticamente",
	"Auto Sort": "Ordenar automaticamente",
	"Auto sort": "Ordenar automaticamente",
	"Playing Time": "Tempo de jogo",
	"Playing time": "Tempo de jogo",
	"Reset playing time": "Redefinir tempo de jogo",
	"Keep auto-sorted": "Manter ordenação automática",
	Starters: "Titulares",
	Bench: "Reservas",
	"Starting Lineup": "Quinteto titular",
	"Team Leaders": "Líderes do time",
	Inbox: "Caixa de entrada",
	"No messages!": "Nenhuma mensagem!",
	"Team Headlines": "Notícias do time",
	"League Headlines": "Notícias da liga",
	"Full Roster": "Elenco completo",
	"League Standings": "Classificação da liga",
	Conference: "Conferência",
	Division: "Divisão",
	Win: "Vitória",
	Loss: "Derrota",
	Wins: "Vitórias",
	Losses: "Derrotas",
	Won: "Vitórias",
	Lost: "Derrotas",
	Home: "Casa",
	Away: "Fora",
	Road: "Fora",
	Streak: "Sequência",
	"Last 10": "Últimos 10",
	Record: "Campanha",
	Rank: "Posição",
	Points: "Pontos",
	Allowed: "Sofridos",
	Rebounds: "Rebotes",
	Assists: "Assistências",
	Steals: "Roubos de bola",
	Blocks: "Tocos",
	Turnovers: "Erros",
	Fouls: "Faltas",
	Minutes: "Minutos",
	Games: "Jogos",
	"Games played": "Jogos disputados",
	"Games Played": "Jogos disputados",
	"Field Goals": "Arremessos de quadra",
	"Free Throws": "Lances livres",
	"Three Pointers": "Bolas de três",
	"Team Finances": "Finanças do time",
	"League Finances": "Finanças da liga",
	Cash: "Caixa",
	Payroll: "Folha salarial",
	"Salary Cap": "Teto salarial",
	"Luxury Tax": "Imposto de luxo",
	Revenue: "Receita",
	Profit: "Lucro",
	Expenses: "Despesas",
	Attendance: "Público",
	"Avg Attendance": "Público médio",
	"Ticket Price": "Preço do ingresso",
	Coaching: "Treinamento",
	Facilities: "Instalações",
	Health: "Saúde",
	Budget: "Orçamento",
	Total: "Total",
	Balance: "Saldo",
	Messages: "Mensagens",
	Message: "Mensagem",
	Notification: "Notificação",
	Notifications: "Notificações",
	News: "Notícias",
	Upcoming: "Próximos",
	Completed: "Concluídos",
	Results: "Resultados",
	Result: "Resultado",
	Today: "Hoje",
	Yesterday: "Ontem",
	Tomorrow: "Amanhã",
	"One day": "Um dia",
	"One Day": "Um dia",
	"One week": "Uma semana",
	"One Week": "Uma semana",
	"One month": "Um mês",
	"One Month": "Um mês",
	"Until playoffs": "Até os playoffs",
	"Until Playoffs": "Até os playoffs",
	"Until regular season": "Até a temporada regular",
	"Until Regular Season": "Até a temporada regular",
	"Until preseason": "Até a pré-temporada",
	"Until Preseason": "Até a pré-temporada",
	"Until draft": "Até o draft",
	"Until Draft": "Até o draft",
	"Until free agency": "Até a agência livre",
	"Until Free Agency": "Até a agência livre",
	"Until re-sign players": "Até as renovações",
	"Until Re-Sign Players": "Até as renovações",
	"Until trade deadline": "Até o limite de trocas",
	"Until Trade Deadline": "Até o limite de trocas",
	"Until All-Star Game": "Até o Jogo das Estrelas",
	"Until end of season": "Até o fim da temporada",
	Stop: "Parar",
	"Stop simulation": "Parar simulação",
	Preseason: "Pré-temporada",
	"Regular Season": "Temporada regular",
	"Regular season": "Temporada regular",
	"After Trade Deadline": "Após o limite de trocas",
	"Before Draft": "Antes do draft",
	"After Draft": "Após o draft",
	"Re-Sign Players": "Renovação de contratos",
	"Free Agency": "Agência livre",
	preseason: "pré-temporada",
	"regular season": "temporada regular",
	playoffs: "playoffs",
	"free agency": "agência livre",
	"draft lottery": "loteria do draft",
	"All-Star": "Jogo das Estrelas",
	"All-Star Game": "Jogo das Estrelas",
	"All-Star History": "Histórico do Jogo das Estrelas",
	Awards: "Prêmios",
	MVP: "MVP",
	"Most Valuable Player": "Jogador mais valioso",
	"Rookie of the Year": "Novato do ano",
	"Defensive Player of the Year": "Defensor do ano",
	"Sixth Man of the Year": "Sexto homem do ano",
	"Most Improved Player": "Jogador que mais evoluiu",
	"Finals MVP": "MVP das finais",
	Champions: "Campeões",
	Champion: "Campeão",
	Finals: "Finais",
	Rookie: "Novato",
	Veteran: "Veterano",
	Best: "Melhor",
	Worst: "Pior",
	Current: "Atual",
	Career: "Carreira",
	"Per Game": "Por jogo",
	"Per game": "Por jogo",
	"Per 36 Minutes": "Por 36 minutos",
	"Per 100 Possessions": "Por 100 posses",
	Totals: "Totais",
	Advanced: "Avançadas",
	Regular: "Regular",
	"Show ratings": "Mostrar atributos",
	"Show Ratings": "Mostrar atributos",
	"Show stats": "Mostrar estatísticas",
	Download: "Baixar",
	Export: "Exportar",
	Import: "Importar",
	Upload: "Enviar arquivo",
	File: "Arquivo",
	"Choose file": "Escolher arquivo",
	"No file chosen": "Nenhum arquivo selecionado",
	"Choose File": "Escolher arquivo",
	"League file": "Arquivo de liga",
	"League File": "Arquivo de liga",
	Teams: "Times",
	Settings: "Configurações",
	Options: "Opções",
	Basic: "Básico",
	General: "Geral",
	"Advanced Settings": "Configurações avançadas",
	Simulation: "Simulação",
	Rules: "Regras",
	Gameplay: "Jogabilidade",
	"Number of teams": "Número de times",
	"Number of games": "Número de partidas",
	"Number of Games": "Número de partidas",
	"Playoff Settings": "Configurações dos playoffs",
	"Draft Settings": "Configurações do draft",
	"Salary Cap Type": "Tipo de teto salarial",
	Soft: "Flexível",
	"Hard Cap": "Teto rígido",
	"No salary cap": "Sem teto salarial",
	"Starting season": "Temporada inicial",
	"Starting Season": "Temporada inicial",
	"Starting phase": "Fase inicial",
	"Starting Phase": "Fase inicial",
	"Keep all teams": "Manter todos os times",
	"Shuffle rosters": "Embaralhar elencos",
	"Shuffle Rosters": "Embaralhar elencos",
	"Delete All Leagues": "Excluir todas as ligas",
	"Delete all leagues": "Excluir todas as ligas",
	"Default New League Settings": "Configurações padrão de novas ligas",
	"Save Settings": "Salvar configurações",
	"Restore Defaults": "Restaurar padrões",
	"Reset to defaults": "Restaurar padrões",
	Enable: "Ativar",
	Disable: "Desativar",
	Enabled: "Ativado",
	Disabled: "Desativado",
	Warning: "Atenção",
	Error: "Erro",
	Success: "Sucesso",
	"Are you sure?": "Tem certeza?",
	Proceed: "Prosseguir",
	Back: "Voltar",
	Next: "Próximo",
	Previous: "Anterior",
	More: "Mais",
	Less: "Menos",
	Details: "Detalhes",
	Summary: "Resumo",
	Overview: "Visão geral",
	View: "Ver",
	"View All": "Ver todos",
	"View all": "Ver todos",
	"Show all": "Mostrar todos",
	"Full name": "Nome completo",
	"First name": "Nome",
	"Last name": "Sobrenome",
	"Jersey Number": "Número da camisa",
	"Jersey number": "Número da camisa",
	Jersey: "Uniforme",
	Colors: "Cores",
	Logo: "Escudo",
	Population: "População",
	"Stadium Capacity": "Capacidade do ginásio",
	Region: "Cidade",
	Abbreviation: "Abreviação",
	"Play Through Injuries": "Jogar com lesões",
	"Retired Jersey Numbers": "Números aposentados",
	"Retired Jerseys": "Camisas aposentadas",
	"Transactions Log": "Registro de transações",
	Player: "Jogador",
	"Team History": "Histórico do time",
	"Player History": "Histórico do jogador",
	"Player Profile": "Perfil do jogador",
	"Player Overview": "Visão geral do jogador",
	Game: "Partida",
	"Box Score": "Súmula",
	"Box score": "Súmula",
	Live: "Ao vivo",
	Watch: "Acompanhar",
	Simulate: "Simular",
	Sim: "Simular",
	"Show more": "Mostrar mais",
	"Show More": "Mostrar mais",
	"Loading player data...": "Carregando jogadores…",
	"Saving...": "Salvando…",
	Saved: "Salvo",
	"Open in new window": "Abrir em nova janela",
	Copy: "Copiar",
	"Copy to clipboard": "Copiar para área de transferência",
	"New Random Players League": "Nova liga com jogadores fictícios",
	"New Real Players League": "Nova liga com jogadores reais",
	"New Custom League": "Nova liga personalizada",
	"New Legends League": "Nova liga de lendas",
	"New Cross-Era League": "Nova liga de épocas diferentes",
	"Welcome to your new league!": "Boas-vindas à sua nova liga!",
	Welcome: "Boas-vindas",
	"No results found.": "Nenhum resultado encontrado.",
	"No players found.": "Nenhum jogador encontrado.",
	"No games": "Nenhuma partida",
	"No games found.": "Nenhuma partida encontrada.",
	"No games scheduled.": "Nenhuma partida agendada.",
	"No games scheduled": "Nenhuma partida agendada",
	"All teams": "Todos os times",
	"All Teams": "Todos os times",
	"All players": "Todos os jogadores",
	"All Players": "Todos os jogadores",
	Available: "Disponível",
	Unavailable: "Indisponível",
	Offense: "Ataque",
	Defense: "Defesa",
	Athleticism: "Atletismo",
	Shooting: "Arremesso",
	Passing: "Passe",
	"Ball Handling": "Controle de bola",
	Rebounding: "Rebote",
	Speed: "Velocidade",
	Strength: "Força",
	Jumping: "Impulsão",
	Endurance: "Resistência",
	"Basketball IQ": "Inteligência de jogo",
	Fired: "Demitido",
	Retirements: "Aposentadorias",
	"Playing...": "Simulando…",
	"Draft in progress...": "Draft em andamento…",
	"Trade accepted!": "Troca aceita!",
	"Trade rejected!": "Troca recusada!",
	"Custom (from league file)": "Personalizada (arquivo de liga)",
	"League files can contain teams, players, settings,":
		"Os arquivos de liga podem conter times, jogadores, configurações,",
	"Increasing difficulty makes AI teams more reluctant to trade with you, makes players less likely to sign with you, and makes it harder to turn a profit.":
		"Aumentar a dificuldade torna os times controlados pelo computador mais exigentes nas trocas, reduz a disposição dos jogadores em assinar com você e dificulta obter lucro.",
	"Try our other sports sim": "Conheça nossos outros jogos de",
	"games!": "simulação esportiva!",
	"Update Available": "Atualização disponível",
	"Update and refresh": "Atualizar e recarregar",
	"Basketball GM is now fully loaded and will continue to work even if you are offline.":
		"O Basketball GM terminou de carregar. No multiplayer, mantenha a conexão com o servidor.",
	"Normal difficulty": "Dificuldade normal",
	"No trade proposals found.": "Nenhuma proposta de troca encontrada.",
	"You have no saved trades.": "Você não tem trocas salvas.",
	"Negotiate contract": "Negociar contrato",
	"Contract negotiation": "Negociação de contrato",
	Projected: "Projetado",
	Actual: "Real",
	Expected: "Esperado",
	Minimum: "Mínimo",
	Maximum: "Máximo",
	Min: "Mín.",
	Max: "Máx.",
	Owner: "Proprietário",
	Status: "Situação",
	"Trade Deadline": "Limite de trocas",
	"Trading deadline": "Limite de trocas",
	"Play-In Tournament": "Torneio de repescagem",
	"Play-In": "Repescagem",
	Expansion: "Expansão",
	Relocation: "Mudança de cidade",
	"Spectator Mode": "Modo espectador",
	Spectator: "Espectador",
	"Team name": "Nome do time",
	"Team Name": "Nome do time",
	"All-Star Teams": "Times do Jogo das Estrelas",
	"Slam Dunk Contest": "Concurso de enterradas",
	"Three-Point Contest": "Concurso de três pontos",
	"Play By Play": "Lance a lance",
	"Play-by-play": "Lance a lance",
	"Last Season": "Última temporada",
	"This Season": "Esta temporada",
	"Next Season": "Próxima temporada",
	"Upcoming Games": "Próximas partidas",
	"Recent Games": "Últimas partidas",
	"Free Agent": "Agente livre",
	"Free agent": "Agente livre",
	"Re-Signing": "Renovação",
	"Ticket price": "Preço do ingresso",
	"Revenue (YTD)": "Receita (na temporada)",
	"Profit (YTD)": "Lucro (na temporada)",
	"Playoff Series": "Séries dos playoffs",
	"Trade Assets": "Ativos de troca",
	"Accept trade": "Aceitar troca",
	"Reject trade": "Recusar troca",
	Propose: "Propor",
	"Reset filters": "Redefinir filtros",
	"Reset Filters": "Redefinir filtros",
	"Search players": "Buscar jogadores",
	"Search Players": "Buscar jogadores",
	"Search...": "Buscar…",
	"No data": "Sem dados",
	"No data available": "Dados indisponíveis",
	"Team record": "Campanha do time",
	"Team Record": "Campanha do time",
	"Points Per Game": "Pontos por jogo",
	"Player of the Game": "Jogador da partida",
	Recommended: "Recomendado",
	Estimated: "Estimado",
	"Unrestricted Free Agent": "Agente livre irrestrito",
	"Restricted Free Agent": "Agente livre restrito",
	"Minimum contract": "Contrato mínimo",
	"Maximum contract": "Contrato máximo",
	"Expiring contracts": "Contratos a vencer",
	"Expiring Contracts": "Contratos a vencer",
	"Payroll limit": "Limite da folha salarial",
	"Playoff Bracket": "Chave dos playoffs",
	"Edit Note": "Editar anotação",
	"Add Note": "Adicionar anotação",
	"Save Note": "Salvar anotação",
	"Delete Note": "Excluir anotação",
	Watchlist: "Lista de interesse",
	Unwatch: "Deixar de acompanhar",
	"Add to Watch List": "Adicionar à lista de interesse",
	"Remove from Watch List": "Remover da lista de interesse",
	"Auto-sort by overall rating": "Ordenar por atributo geral",
	Randomize: "Sortear",
	Change: "Alterar",
	Replace: "Substituir",
	Add: "Adicionar",
	Remove: "Remover",
	"Player Development": "Desenvolvimento dos jogadores",
	"Player development": "Desenvolvimento dos jogadores",
	"Team Strategy": "Estratégia do time",
	Keep: "Manter",
	"Best Available": "Melhor disponível",
	"Available Funds": "Saldo disponível",
	Remaining: "Restantes",
	"Completed Games": "Partidas concluídas",
	"Upload file": "Enviar arquivo",
	"League URL": "URL da liga",
	Validate: "Validar",
	"Importing...": "Importando…",
	"Creating league...": "Criando liga…",
	"Preparing...": "Preparando…",
};

const textTranslation = (value: string): string => {
	const trimmed = value.trim().replace(/\s+/g, " ");
	let translated = words[trimmed];
	if (trimmed.startsWith("» ") && words[trimmed.slice(2)]) {
		translated = "» " + words[trimmed.slice(2)];
	}
	if (!translated) {
		translated = trimmed
			.replace(/^(\d{4}) preseason$/, "$1 pré-temporada")
			.replace(/^(\d{4}) regular season$/, "$1 temporada regular")
			.replace(/^(\d{4}) free agency$/, "$1 agência livre");
		if (translated === trimmed) {
			translated = trimmed
				.replace(/^(.+) Dashboard$/, "Painel de $1")
				.replace(/^(.+) Roster$/, "Elenco de $1")
				.replace(/^(.+) Finances$/, "Finanças de $1")
				.replace(/^(.+) Schedule$/, "Calendário de $1")
				.replace(/^(\d+)(st|nd|rd|th) in conference$/, "$1º na conferência");
		}
	}
	return translated === trimmed
		? value
		: value.replace(value.trim(), translated);
};
export const installPTBR = () => {
	if ((globalThis as any).__bbgmServerBridge) {
		return;
	}
	let language = localStorage.getItem("bbgm-language") ?? "pt-BR";
	const originals = new WeakMap<
		Node,
		{ original: string; translated: string }
	>();
	const translate = (root: Node) => {
		const apply = (node: Node) => {
			const parent = node.parentElement;
			if (
				!parent ||
				parent.closest(
					"script,style,textarea,input,[contenteditable],#bbgm-language",
				)
			) {
				return;
			}
			const current = node.nodeValue ?? "";
			const prev = originals.get(node);
			const original =
				prev && current === prev.translated ? prev.original : current;
			const translated =
				language === "pt-BR" ? textTranslation(original) : original;
			originals.set(node, { original, translated });
			if (current !== translated) {
				node.nodeValue = translated;
			}
		};
		if (root.nodeType === Node.TEXT_NODE) {
			apply(root);
		} else {
			const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
			while (walker.nextNode()) {
				apply(walker.currentNode);
			}
		}
	};
	const observer = new MutationObserver((records) => {
		observer.disconnect();
		for (const record of records) {
			if (record.type === "characterData") {
				translate(record.target);
			} else {
				for (const node of record.addedNodes) {
					translate(node);
				}
			}
		}
		observer.observe(document.body, {
			subtree: true,
			childList: true,
			characterData: true,
		});
	});
	const start = () => {
		const selector = document.createElement("select");
		selector.id = "bbgm-language";
		selector.setAttribute("aria-label", "Idioma / Language");
		selector.style.cssText =
			"position:fixed;right:12px;bottom:54px;z-index:1040;width:auto;border:1px solid #9aa4b2;border-radius:6px;padding:5px;background:#172536;color:white;font:12px system-ui";
		for (const [value, label] of [
			["pt-BR", "Português (Brasil)"],
			["en", "English"],
		]) {
			const option = document.createElement("option");
			option.value = value!;
			option.textContent = label!;
			selector.append(option);
		}
		selector.value = language;
		selector.onchange = () => {
			language = selector.value;
			localStorage.setItem("bbgm-language", language);
			observer.disconnect();
			translate(document.body);
			observer.observe(document.body, {
				subtree: true,
				childList: true,
				characterData: true,
			});
			document.documentElement.lang = language;
		};
		document.body.append(selector);
		translate(document.body);
		document.documentElement.lang = language;
		observer.observe(document.body, {
			subtree: true,
			childList: true,
			characterData: true,
		});
	};
	if (document.body) {
		start();
	} else {
		document.addEventListener("DOMContentLoaded", start, { once: true });
	}
};
